module.exports = __webpack_public_path__ + "assets/squarespace.8721845c.svg";